<template>
  <div class="FuLin">
    <!--春季：3-5月-->
    <div class="spring" v-if="nowMoth >= 3 && nowMoth <= 8">
      <div class="banner">
        <img width="100%" src="../../../assets/img/FuLin/FuLin_Banner_spring.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="50%" style="float:left;" src="../../../assets/img/FuLin/spring_pipaPic.png" alt="" srcset="">
          <img width="50%" style="float:right;" src="../../../assets/img/FuLin/spring_huangguoganPic.png" alt=""
            srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/FuLin/FuLin_spring_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p style="color:#CF9118;font-weight:bold;">枇杷</p>
            <p>富林镇2021年枇杷种植约2800余亩，主要种植地为流沙河社区、青富村、富塘村、市荣社区和饮泉社区，年产量达252万斤，年产值约2400万元。</p>
            <p style="color:#CF9118;font-weight:bold;">黄果柑</p>
            <p>富林镇2021年黄果柑种植约2500余亩，主要种植地为西园社区、流沙河社区、青富村、富塘村、市荣社区和饮泉社区，年产量达775万斤，年产值约1550万元。</p>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/FuLin/FuLin_spring_square.png')"
        color="#CF9118" borderBottomColor="#CF9118" boxBorderColor="#D7A23C" btnBJcolor="#E4C487" hoverBJcolor="#CF9118">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/FuLin/FuLin_spring_square.png')"
        color="#CF9118" borderBottomColor="#CF9118"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/FuLin/FuLin_spring_square.png')" color="#CF9118"
        borderBottomColor="#CF9118" boxBorderColor="#D7A23C"></ztxzList>
    </div>
    <!-- 秋季：9-11月 -->
    <div class="autumn" v-else-if="(nowMoth >= 9 && nowMoth <= 12) || (nowMoth >= 1 && nowMoth <= 2)">
      <div class="banner">
        <img width="100%" src="../../../assets/img/FuLin/FuLin_Banner_autumn.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/FuLin/autumn_pingguoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/FuLin/FuLin_autumn_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              富林镇2021年苹果种植约3400余亩，主要种植地为青富村、富塘村和太平村，年产量达1088万斤，年产值约2720万元。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/FuLin/autumn_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/FuLin/FuLin_autumn_square.png')"
        color="#9D0012" borderBottomColor="#9D0012" boxBorderColor="#D2959E" btnBJcolor="#CC7F89" hoverBJcolor="#A00318">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/FuLin/FuLin_autumn_square.png')"
        color="#9D0012" borderBottomColor="#9D0012"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/FuLin/FuLin_autumn_square.png')" color="#9D0012"
        borderBottomColor="#9D0012" boxBorderColor="#D2959E"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'FuLin',
  components: { ztxzList, ConvenientService ,GovernmentServices},
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'富林镇'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // } else {
  //   //   if (sessionStorage.getItem('mapId')) {
  //   //     this.mapId = sessionStorage.getItem('mapId');
  //   //   }
  //   // }

  //   this.getData()
  //   this.getMatterList()
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.FuLin {
  background: url('../../../../src/assets/img/FuLin/FuLin_Bj.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  /*text-indent: 2em;*/
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 30px;
}

.spring .top_title {
  color: #CF9118;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #CF9118;
  height: 12%;
}


.autumn .top_title {
  color: #9D0012;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #9D0012;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}
</style>